import { useQuery } from 'react-query';
import { BackgroundImage } from 'src/core/types';

import axios from './axios';

export function useBackgroundImages() {
  return useQuery<Array<BackgroundImage>>('background-images', async () => {
    return axios
      .get<Array<BackgroundImage>>(`/posht/picasso/background-images/`)
      .then((res) => res.data);
  });
}
